/**
 * Session persistence for the post-login "missing notary contact email" prompt.
 * All reads/writes go through this module (single place for the storage key and SSR guards).
 */
export const NOTARY_CONTACT_EMAIL_PROMPT_DISMISS_STORAGE_KEY = "notary_contact_email_prompt_dismissed";

function canUseSessionStorage(): boolean {
	return typeof window !== "undefined";
}

export function isNotaryContactEmailPromptDismissedInSession(): boolean {
	if (!canUseSessionStorage()) {
		return false;
	}
	return sessionStorage.getItem(NOTARY_CONTACT_EMAIL_PROMPT_DISMISS_STORAGE_KEY) === "1";
}

export function setNotaryContactEmailPromptDismissedInSession(): void {
	if (canUseSessionStorage()) {
		sessionStorage.setItem(NOTARY_CONTACT_EMAIL_PROMPT_DISMISS_STORAGE_KEY, "1");
	}
}

export function clearNotaryContactEmailPromptDismissedInSession(): void {
	if (canUseSessionStorage()) {
		sessionStorage.removeItem(NOTARY_CONTACT_EMAIL_PROMPT_DISMISS_STORAGE_KEY);
	}
}
